//@ts-nocheck
"use client"
import Description from "../atoms/description"
import SectionName from "../atoms/section-name"
import Title from "../atoms/title"
import styles from './narrative-slider.module.css'
import Slider from "../atoms/slider";
import MoonWalker from "../atoms/moonwalker";
import { useEffect } from "react";
import CTABtn from "../atoms/cta-btn"


export default function NarrativeSlider({ title, sectionName, description, vxi_contents, sliderList, titlePositioning = "start", button, mode = "slider" }) {
    const buttonAttrs = button?.attributes ?? button;
    // useEffect(() => {
    //     console.log("from nar slider", sliderList, vxi_contents);
    // }, [sliderList, vxi_contents])
    return (
        <div className={styles["narrative-wrapper"]}>
            <div className={styles["narrative-header"]} data-alignment={titlePositioning}>
                <SectionName sectionName={sectionName} />
                <Title title={title} textAlign={titlePositioning} />
                <Description description={description} width={75} />
            </div>
            <div>
                {(!vxi_contents || vxi_contents?.length === 0) && (!sliderList || sliderList?.length === 0) ? <div>We didn't find a match...</div> : <MoonWalker vxi_contents={vxi_contents} sliderList={sliderList} mode={mode} />}
            </div>
            {buttonAttrs && (<div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
                <CTABtn btnName={buttonAttrs.buttonName} btnURL={buttonAttrs.buttonURL} newTab={buttonAttrs.newTab} />
            </div>)}
        </div>
    )
};